import { render, staticRenderFns } from "./newLoginType.vue?vue&type=template&id=2d979f2c&scoped=true&"
import script from "./newLoginType.vue?vue&type=script&lang=js&"
export * from "./newLoginType.vue?vue&type=script&lang=js&"
import style0 from "./newLoginType.vue?vue&type=style&index=0&id=2d979f2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d979f2c",
  null
  
)

export default component.exports